module.exports = __webpack_public_path__ + "img/step22_a_stand_power_remove_stacker_tray.52cf210f.png";